<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <label class="required col-form-label">{{
          $t('expensePosting.reimburseBy')
        }}</label>
        <a-select v-model="model.reimburse_by" :options="employees" show-search option-filter-prop="children"
          class="ts-w-full" :class="{ 'is-invalid': errors.has('reimburse_by') }" placeholder="Select"></a-select>
        <div class="validate ts-text-xs" v-if="errors.has('reimburse_by')">
          {{ errors.first('reimburse_by') }}
        </div>
      </div>
    </div>
    <div class="row ts-mt-3">
      <div class="col-md-12 ts-flex ts-justify-end ts-space-x-3">
        <ts-button @click="$emit('cancel')">{{ $t('cancel') }}</ts-button>
        <ts-button color="primary" :waiting="loading" @click.prevent="onSave">{{ $t('save')
          }}</ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'formCreatePaymentToVendor',
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        exp_main_id: null,
        expense_status: 2,
        reimburse_by: null
      }
    }
  },
  async created() {
    this.getPreData()
  },
  computed: {
    ...mapState('expense/expensePosting', ['formViewDatas', 'edit_data']),
    employees() {
      if (this.formViewDatas['employees']) {
        return this.formViewDatas['employees'].map(el => ({
          value: el.employee_id,
          label: el.employee_name_en + '|' + el.employee_name_kh
        }))
      }
      return []
    },
  },
  methods: {
    ...mapActions('expense/expensePosting', [
      'getFormViewModel',
      'updateStatus',
    ]),
    setData() {
      this.model.exp_main_id = this.edit_data.exp_main_id
      this.model.reimburse_by = this.edit_data.reimburse_by
    },
    async getPreData() {
      this.loading = true
      await this.getFormViewModel({
        index: undefined,
        params: {
          fnName: 'employees'
        }
      })
        .then(() => {
          this.setData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    onSave() {
      this.loading = true
      this.updateStatus(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$emit('cancel')
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
  }
}
</script>
